export default function usePropStyles(fieldWidth: string | number | undefined) {
  const styles = {
    width: fieldWidth ? fieldWidth : '100%',
  }
  return styles
}
